export default __webpack_public_path__ + "static/media/icon-info-new.3b7d8643.svg";